if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.target = document.getElementById(this.dataset.targetId);
        this.realButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('.sticky-buy-bar__button');
        this.buttonText = this.querySelector('.sticky-buy-bar__button-text');
        this.spinner = this.querySelector('.sticky-buy-bar__spinner');
        this.priceWrapper = this.querySelector('.sticky-buy-bar__price');
        this.variantTitle = this.querySelector('[data-sticky-variant-title]');

        if (!this.target || !this.realButton) return;

        this.button.addEventListener('click', this.onButtonClick.bind(this));

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.classList.toggle('is-visible', !entry.isIntersecting));
        });
        this.observer.observe(this.target);

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.setLoading(false));
        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => this.setLoading(false));
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.cartUpdateUnsubscriber?.();
        this.cartErrorUnsubscriber?.();
        this.variantChangeUnsubscriber?.();
      }

      onButtonClick() {
        if (this.realButton.hasAttribute('disabled') || this.realButton.getAttribute('aria-disabled') === 'true') {
          return;
        }
        this.setLoading(true);
        this.realButton.click();
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;
        const { variant, html } = event.data;

        const newPrice = html.getElementById(`price-${this.sectionId}`);
        if (newPrice && this.priceWrapper) this.priceWrapper.innerHTML = newPrice.innerHTML;

        if (this.variantTitle && variant) this.variantTitle.textContent = variant.title;

        const unavailable = !variant || variant.available === false;
        this.button.disabled = unavailable;
        if (this.buttonText) {
          this.buttonText.textContent = !variant
            ? window.variantStrings.unavailable
            : unavailable
              ? window.variantStrings.soldOut
              : this.dataset.buttonTextOverride || window.variantStrings.addToCart;
        }
      }

      setLoading(isLoading) {
        this.classList.toggle('loading', isLoading);
        this.button.disabled = isLoading;
        this.spinner?.classList.toggle('hidden', !isLoading);
      }
    }
  );
}
